import { useMessagingSocket } from "./hooks/use-messaging-socket.ts"

/**
 * Holds the app's one messaging socket.
 *
 * Mounted in the shell rather than on the Messages page, because the unread
 * badge in the navigation has to stay live wherever the user is — and because
 * a second socket per screen would double every delivery.
 */
export function MessagingController({ portal = false }: { portal?: boolean }) {
  useMessagingSocket({ portal })
  return null
}

export default MessagingController
